import axios from 'axios'

export default () => {
    return {
        api: null,
        list: null,
        name: null,
        email: null,
        response: null,

        mounted(api, list) {
            this.api = api
            this.list = list
        },

        subscribe() {
            const requestData = new FormData()
            requestData.append('action', 'newsletter')
            requestData.append('name', this.name)
            requestData.append('email', this.email)
            requestData.append('api', this.api)
            requestData.append('list', this.list)

            axios
                .post(winshape.ajaxurl, requestData)
                .then(response => {
                    console.log(response)
                    this.response = response.data
                })
                .catch(error => {
                    console.log(error)
                })
        },
    }
}
